<div class="image-dialog">
    <img [src]="data.image" alt="Preview Image">
</div>